/* eslint-disable react-native/no-color-literals */
import { colors } from "colors"
import { Dimensions, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  capturedImage: {
    height: "80%",
    marginVertical: "1vw",
    resizeMode: "contain",
    width: "80%",
  },
  container: { height: "100%", padding: 10 },
  imageStyle: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    marginHorizontal: 100,
    maxWidth: 600,
    width: "100%",
  },
  mediaContainer: {
    alignItems: "center",
    backgroundColor: "grey",
    display: "flex",
    height: "50%",
    justifyContent: "center",
    maxHeight: 400,
    width: "100%",
  },
  modalButton: {
    color: colors.white,
  },
  modalContainer: {
    alignItems: "center",
    display: "flex",
    height: Dimensions.get("window").height,
    margin: 0,
    padding: 0,
    width: Dimensions.get("window").width,
  },
  modalContentButton: {
    alignItems: "center",
    borderRadius: 10,
    borderWidth: 3,
    padding: 10,
    textAlign: "center",
    width: "100%",
  },
  modalContentContainer: {
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: 20,
    height: "30%",
    justifyContent: "space-around",
    maxWidth: 800,
    padding: 15,
    width: "80%",
  },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    textAlign: "center",
  },
})
